import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { PerformanceService } from '../../services/performance-service';

export const PerformanceMeasure = React.memo(({ children, end, name, start }) => {
  useEffect(() => {
    if (start && end) {
      PerformanceService.measure(name, start, end);
    }
  }, [end, name, start]);

  if (!children) {
    return null;
  }

  return <React.Fragment>{children}</React.Fragment>;
});

PerformanceMeasure.displayName = 'PerformanceMeasure';
PerformanceMeasure.propTypes = {
  children: PropTypes.node,
  end: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  name: PropTypes.string.isRequired,
  start: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};
